import React from 'react'

import { Button, getValidIcon, Tag } from 'components/ui'
import { HighlightCardStoryblok } from 'lib/storyblok/types'
import { getAnchorFromCmsLink } from 'lib/utils/content'
import { cn } from 'lib/utils/tailwind'

import { StoryblokImage } from '../StoryblokImage'

type Props = {
  block: HighlightCardStoryblok
  variant?: 'default' | 'richtext'
}

export const HighlightCard = ({
  block,
  variant = 'default',
  ...rest
}: Props): JSX.Element => {
  const { tag, title, description, link, media } = block
  return (
    <section
      {...rest}
      className={cn(
        'max-w-screen-desktop px-5 lg:px-20 mx-auto py-10 lg:py-15',
        variant === 'richtext' && 'flex items-center justify-center'
      )}
    >
      <div
        className={cn(
          'flex flex-col bg-foreground/5 rounded-4 lg:flex-row lg:justify-between lg:gap-20',
          variant === 'richtext' &&
            'h-[487px] w-full max-w-[994px] lg:gap-[30px]'
        )}
      >
        <div
          className={cn(
            'flex flex-col justify-between p-8 pb-10 md:p-5 lg:p-8 lg:pr-0 lg:max-w-[377px] gap-15',
            variant === 'richtext' && 'lg:max-w-[416px]'
          )}
        >
          <div className="space-y-4">
            {tag && <Tag>{tag}</Tag>}
            <h2 className="text-title-large font-regular">{title}</h2>
          </div>

          <div className="space-y-8 lg:space-y-5">
            <p className="text-twenty text-foreground/80">{description}</p>

            {link?.length && link[0] && link[0].link && (
              <Button
                as="a"
                rel={getAnchorFromCmsLink(link[0].link).rel}
                href={getAnchorFromCmsLink(link[0].link).href}
                target={getAnchorFromCmsLink(link[0].link).target}
                variant={variant === 'default' ? 'outline' : 'primary'}
                icon={
                  variant === 'default'
                    ? 'arrow-right'
                    : getValidIcon(link[0].icon)
                }
                iconPosition={variant === 'default' ? 'right' : 'left'}
              >
                {link[0].label}
              </Button>
            )}
          </div>
        </div>

        {media?.filename && (
          <div className="p-2 pt-2 lg:pt-2 lg:h-auto w-full h-[319px]">
            <div className="overflow-hidden relative h-full w-full rounded-4">
              <StoryblokImage
                fill
                asset={media}
                height={undefined}
                width={undefined}
                className="object-cover"
              />
            </div>
          </div>
        )}
      </div>
    </section>
  )
}
